import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-78ab75f8"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "row",
  style: {"padding":"1.25rem"}
}
const _hoisted_2 = { class: "col-12 col-md-8" }
const _hoisted_3 = { class: "row" }
const _hoisted_4 = { class: "col-12 col-sm-4" }
const _hoisted_5 = { class: "small-box bg-warning" }
const _hoisted_6 = { class: "inner" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "流程发起人", -1))
const _hoisted_8 = { class: "icon" }
const _hoisted_9 = { class: "col-12 col-sm-4" }
const _hoisted_10 = { class: "small-box bg-warning" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "inner" }, [
  /*#__PURE__*/_createElementVNode("h2", null, "1天23小时"),
  /*#__PURE__*/_createElementVNode("p", null, "启动持续")
], -1))
const _hoisted_12 = { class: "icon" }
const _hoisted_13 = { class: "col-12 col-sm-4" }
const _hoisted_14 = { class: "small-box bg-warning" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "inner" }, [
  /*#__PURE__*/_createElementVNode("h2", null, "1天23小时"),
  /*#__PURE__*/_createElementVNode("p", null, "到达持续")
], -1))
const _hoisted_16 = { class: "icon" }
const _hoisted_17 = { class: "col-12 col-md-12 card card-default w-100" }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "card-header" }, [
  /*#__PURE__*/_createElementVNode("h3", { class: "card-title" }, "表单信息")
], -1))
const _hoisted_19 = { class: "card-body" }
const _hoisted_20 = { class: "col-12 col-md-4" }
const _hoisted_21 = { class: "card card-default" }
const _hoisted_22 = { class: "card-header" }
const _hoisted_23 = { class: "card-title" }
const _hoisted_24 = { class: "card-body" }
const _hoisted_25 = { class: "card-footer" }
const _hoisted_26 = /*#__PURE__*/_createTextVNode(" 同意")
const _hoisted_27 = /*#__PURE__*/_createTextVNode(" 驳回")
const _hoisted_28 = /*#__PURE__*/_createTextVNode(" 委派")
const _hoisted_29 = /*#__PURE__*/_createTextVNode(" 转办")
const _hoisted_30 = /*#__PURE__*/_createTextVNode(" 撤销")
const _hoisted_31 = /*#__PURE__*/_createTextVNode(" 退回")
const _hoisted_32 = /*#__PURE__*/_createTextVNode(" 加签")
const _hoisted_33 = /*#__PURE__*/_createTextVNode(" 减签")
const _hoisted_34 = /*#__PURE__*/_createTextVNode(" 评论")
const _hoisted_35 = /*#__PURE__*/_createTextVNode(" 查到签上的人")

export function render(_ctx, _cache) {
  const _component_UserFilled = _resolveComponent("UserFilled")
  const _component_el_icon = _resolveComponent("el-icon")
  const _component_Timer = _resolveComponent("Timer")
  const _component_form_render = _resolveComponent("form-render")
  const _component_el_option = _resolveComponent("el-option")
  const _component_el_select = _resolveComponent("el-select")
  const _component_el_form_item = _resolveComponent("el-form-item")
  const _component_el_input = _resolveComponent("el-input")
  const _component_el_form = _resolveComponent("el-form")
  const _component_svg_icon = _resolveComponent("svg-icon")

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("h2", null, _toDisplayString(_ctx.startUserName), 1),
              _hoisted_7
            ]),
            _createElementVNode("div", _hoisted_8, [
              _createVNode(_component_el_icon, { style: {"top":"0"} }, {
                default: _withCtx(() => [
                  _createVNode(_component_UserFilled)
                ]),
                _: 1
              })
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_9, [
          _createElementVNode("div", _hoisted_10, [
            _hoisted_11,
            _createElementVNode("div", _hoisted_12, [
              _createVNode(_component_el_icon, { style: {"top":"0"} }, {
                default: _withCtx(() => [
                  _createVNode(_component_Timer)
                ]),
                _: 1
              })
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_13, [
          _createElementVNode("div", _hoisted_14, [
            _hoisted_15,
            _createElementVNode("div", _hoisted_16, [
              _createVNode(_component_el_icon, { style: {"top":"0"} }, {
                default: _withCtx(() => [
                  _createVNode(_component_Timer)
                ]),
                _: 1
              })
            ])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_17, [
        _hoisted_18,
        _createElementVNode("div", _hoisted_19, [
          _createVNode(_component_form_render, {
            class: "process-form",
            mode: "PC",
            ref: "form",
            forms: _ctx.formItems,
            modelValue: _ctx.formData,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => ((_ctx.formData) = $event))
          }, null, 8, ["forms", "modelValue"])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_20, [
      _createElementVNode("div", _hoisted_21, [
        _createElementVNode("div", _hoisted_22, [
          _createElementVNode("h3", _hoisted_23, _toDisplayString(`${_ctx.startUserName}提交的${_ctx.templateName}`), 1)
        ]),
        _createElementVNode("div", _hoisted_24, [
          _createVNode(_component_el_form, {
            model: _ctx.approveForm,
            "label-width": "120px",
            "label-position": "top"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_form_item, { label: "加签用户" }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_select, {
                    size: "large",
                    modelValue: _ctx.approveForm.comments,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => ((_ctx.approveForm.comments) = $event)),
                    placeholder: "请选择用户",
                    style: {"width":"100%"}
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_option, {
                        label: "张三",
                        value: "1"
                      }),
                      _createVNode(_component_el_option, {
                        label: "张四",
                        value: "2"
                      })
                    ]),
                    _: 1
                  }, 8, ["modelValue"])
                ]),
                _: 1
              }),
              _createVNode(_component_el_form_item, { label: "转办用户" }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_select, {
                    size: "large",
                    modelValue: _ctx.approveForm.comments,
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => ((_ctx.approveForm.comments) = $event)),
                    placeholder: "请选择用户",
                    style: {"width":"100%"}
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_option, {
                        label: "张三",
                        value: "1"
                      }),
                      _createVNode(_component_el_option, {
                        label: "张四",
                        value: "2"
                      })
                    ]),
                    _: 1
                  }, 8, ["modelValue"])
                ]),
                _: 1
              }),
              _createVNode(_component_el_form_item, { label: "委派用户" }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_select, {
                    size: "large",
                    modelValue: _ctx.approveForm.comments,
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => ((_ctx.approveForm.comments) = $event)),
                    placeholder: "请选择用户",
                    style: {"width":"100%"}
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_option, {
                        label: "张三",
                        value: "1"
                      }),
                      _createVNode(_component_el_option, {
                        label: "张四",
                        value: "2"
                      })
                    ]),
                    _: 1
                  }, 8, ["modelValue"])
                ]),
                _: 1
              }),
              _createVNode(_component_el_form_item, { label: "审批意见" }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_input, {
                    size: "large",
                    modelValue: _ctx.approveForm.comments,
                    "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => ((_ctx.approveForm.comments) = $event)),
                    type: "textarea"
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["model"])
        ]),
        _createElementVNode("div", _hoisted_25, [
          _createElementVNode("button", {
            type: "button",
            class: "btn btn-themes m-1",
            onClick: _cache[5] || (_cache[5] = $event => (_ctx.onAgree()))
          }, [
            _createVNode(_component_svg_icon, { name: "stamp" }),
            _hoisted_26
          ]),
          _createElementVNode("button", {
            type: "button",
            class: "btn btn-themes m-1",
            onClick: _cache[6] || (_cache[6] = $event => (_ctx.onRefuse()))
          }, [
            _createVNode(_component_svg_icon, { name: "stamp" }),
            _hoisted_27
          ]),
          _createElementVNode("button", {
            type: "button",
            class: "btn btn-themes m-1",
            onClick: _cache[7] || (_cache[7] = $event => (_ctx.onDelegate()))
          }, [
            _createVNode(_component_svg_icon, { name: "stamp" }),
            _hoisted_28
          ]),
          _createElementVNode("button", {
            type: "button",
            class: "btn btn-themes m-1",
            onClick: _cache[8] || (_cache[8] = $event => (_ctx.onAssignee()))
          }, [
            _createVNode(_component_svg_icon, { name: "stamp" }),
            _hoisted_29
          ]),
          _createElementVNode("button", {
            type: "button",
            class: "btn btn-themes m-1",
            onClick: _cache[9] || (_cache[9] = $event => (_ctx.onRevoke()))
          }, [
            _createVNode(_component_svg_icon, { name: "stamp" }),
            _hoisted_30
          ]),
          _createElementVNode("button", {
            type: "button",
            class: "btn btn-themes m-1",
            onClick: _cache[10] || (_cache[10] = $event => (_ctx.onRollback()))
          }, [
            _createVNode(_component_svg_icon, { name: "stamp" }),
            _hoisted_31
          ]),
          _createElementVNode("button", {
            type: "button",
            class: "btn btn-themes m-1",
            onClick: _cache[11] || (_cache[11] = $event => (_ctx.onAddMulti()))
          }, [
            _createVNode(_component_svg_icon, { name: "stamp" }),
            _hoisted_32
          ]),
          _createElementVNode("button", {
            type: "button",
            class: "btn btn-themes m-1",
            onClick: _cache[12] || (_cache[12] = $event => (_ctx.onDeleteMulti()))
          }, [
            _createVNode(_component_svg_icon, { name: "stamp" }),
            _hoisted_33
          ]),
          _createElementVNode("button", {
            type: "button",
            class: "btn btn-themes m-1",
            onClick: _cache[13] || (_cache[13] = $event => (_ctx.onComments()))
          }, [
            _createVNode(_component_svg_icon, { name: "stamp" }),
            _hoisted_34
          ]),
          _createElementVNode("button", {
            type: "button",
            class: "btn btn-themes m-1",
            onClick: _cache[14] || (_cache[14] = $event => (_ctx.onQueryMultiUsersInfo()))
          }, [
            _createVNode(_component_svg_icon, { name: "close-outline" }),
            _hoisted_35
          ])
        ])
      ])
    ])
  ]))
}